"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMeterType = exports.isActiveElectricitySupply = exports.isActiveGasSupply = exports.isActiveSupply = void 0;
var date_fns_1 = require("date-fns");
var isActiveSupply = function (supply) {
    if (supply === null) {
        return false;
    }
    if (supply.end) {
        return !(0, date_fns_1.isBefore)(supply.end, (0, date_fns_1.subDays)(new Date(), 1));
    }
    else {
        return supply.end === null;
    }
};
exports.isActiveSupply = isActiveSupply;
var isActiveGasSupply = function (supply) {
    return supply.fuel === 'Gas' && (0, exports.isActiveSupply)(supply);
};
exports.isActiveGasSupply = isActiveGasSupply;
var isActiveElectricitySupply = function (supply) {
    return supply.fuel === 'Electricity' && (0, exports.isActiveSupply)(supply);
};
exports.isActiveElectricitySupply = isActiveElectricitySupply;
var getMeterType = function (supplyPoint) {
    if (!supplyPoint) {
        return;
    }
    // Currently it seems the endpoint response doesnt match the type. This is a workaround for now.
    var meterType = supplyPoint.supplyPointInfo
        ? supplyPoint.supplyPointInfo.meterType
        : // @ts-ignore.
            supplyPoint.meterType;
    if (meterType) {
        if (meterType.startsWith('S1') || meterType.startsWith('S2')) {
            return 'smart';
        }
        return 'traditional';
    }
};
exports.getMeterType = getMeterType;
